export const personalData = {
    accountMenuItems: [
        { title: 'Личные данные', value: 10, icon: 'mdi-account-circle-outline' },
        { title: 'История заказов', value: 11, icon: 'mdi-cart-outline' },
        { title: 'Выйти', value: 12, icon: 'mdi-logout' },
    ],
};
